/**
 * Losing the jet (GDD §4.4, §4.6; concept L1110–L1116): the jet explodes and the wreck burns for 2.8 s.
 */
import { config } from '../core/config.ts';
import { pushEvent, type GameSim } from '../sim/context.ts';
import type { CrashCause } from '../sim/state.ts';

/** Jet explosion size (concept L1113). */
const JET_BLAST = 1.8;

export function crash(sim: GameSim, cause: CrashCause): void {
  const run = sim.run;
  if (!run.alive) return;
  run.alive = false;
  run.deadT = config.lives.wreckSec;
  run.lives--;
  sim.fx.boom(sim.jet.x, sim.jet.y, sim.jet.z, JET_BLAST);
  run.jetVisible = false;
  run.lastCause = cause;
  run.crashes++;
  pushEvent(sim, 'jetLost', run.level, cause);
  // Concept rules respawn in place and back off after hitting the bridge (D9; GDD rules use the checkpoint).
  if (sim.rules === 'concept' && cause === 'bridge') run.backoff = true;
}
